import(/* webpackMode: "eager" */ "/app/web/app/(commonLayout)/ecs/user/page.tsx");
